export const CommonDefinitions = {
  Cities: [],
};
